/*
 * Monitor visibility derived once for the route, PixiStage, AppBar and the dock panels. `ABLY_SESSION_CHANNEL` (a ?channel= dev stream) counts as running with no orc session.
 */
import { createSelector } from '@reduxjs/toolkit'
import { ABLY_SESSION_CHANNEL, SESSION_STATUS } from '~/lib/constants'
import { selectSessionStatus } from '~/store/api/selectors'
import { selectIsActiveOutput } from '~/store/app/selectors'
import { selectUsePixi } from '~/store/settings/selectors'
import { selectShow } from '~/store/ui/selectors'

export const selectEffectiveRunning = createSelector(
	selectSessionStatus,
	status => status === SESSION_STATUS.RUNNING || !!ABLY_SESSION_CHANNEL
)

// While running, shown is received; the mirror alone can keep it received with the monitor hidden.
export const selectEffectiveShowOutput = createSelector(
	selectEffectiveRunning,
	selectIsActiveOutput,
	selectShow,
	s => s.ui.monitor_hidden,
	(running, isActiveOutput, show, hidden) => (running ? isActiveOutput && !hidden : show.output)
)

export const selectEffectiveOverlay = createSelector(
	selectUsePixi,
	selectShow,
	(usePixi, show) => usePixi && (!show.source || show.minimal)
)

export const selectOverlayShowsOutput = createSelector(
	selectEffectiveOverlay,
	selectEffectiveShowOutput,
	selectEffectiveRunning,
	(overlay, showOutput, running) => overlay && showOutput && running
)
